import CosmosAdminDbRecordBase from '@/models/CosmosAdminDbRecordBase'

export default class CETWayNoteModel extends CosmosAdminDbRecordBase {
  public note: string

  public constructor() {
    super()
  }
}
